import './App.css';

import Video from './components/Video';

import React from 'react';

let dragInitialPosition;

function cover(
	newWidth,
	newHeight,
	childWidth,
	childHeight,
	scale = 1,
	offsetX = 0.5,
	offsetY = 0.5
) {
	const childRatio = childWidth / childHeight;
	const parentRatio = newWidth / newHeight;
	let width = newWidth * scale;
	let height = newHeight * scale;

	if (childRatio < parentRatio) {
		height = width / childRatio;
	} else {
		width = height * childRatio;
	}

	return {
		width,
		height,
		offsetX: (newWidth - width) * offsetX,
		offsetY: (newHeight - height) * offsetY
	};
}

const frameCount = 120;
const midFrame = frameCount / 2;

let currentImage;
const preloadedImages = [];
const transformations = [];

let isDragging = false;
let lastFrame = midFrame;

let keyFrame = midFrame;

const dragRelease = (frameNum = lastFrame) => {
	isDragging = false;

	if (frameNum !== midFrame) {
		easeToCenter(frameNum);
	}
};

const dragStart = () => {
	isDragging = true;
	keyFrame = lastFrame;
};

const easeToCenter = () => {
	let difference = midFrame - lastFrame;

	let nextDifferential = difference / midFrame;

	if (nextDifferential > 0) {
		nextDifferential = Math.ceil(nextDifferential);
	} else {
		nextDifferential = Math.floor(nextDifferential);
	}

	update(lastFrame + nextDifferential);

	if (!isDragging && lastFrame !== midFrame) {
		requestAnimationFrame(() => easeToCenter(lastFrame));
	}
};

const getImageSrc = (frameNumber) => `frames/${frameNumber.toString().padStart(4, '0')}.webp`;

const parentWidth = window.innerWidth;
const parentHeight = window.innerHeight;
const imageWidth = 1920;
const imageHeight = 1080;

let { offsetX, offsetY, width, height } = cover(parentWidth, parentHeight, imageWidth, imageHeight);

// let lastFrame = midFrame;
let scene;
let context;

const limitFrameNumber = (num) => {
	const MIN = 1;
	const MAX = frameCount;
	const roundedNumber = Math.round(num);

	return Math.min(Math.max(roundedNumber, MIN), MAX);
};

const areaWidth = window.innerWidth / 1.8;

const getFrameNumber = (positionInArea) => (positionInArea * frameCount) / areaWidth + keyFrame;

const preloadImages = () => {
	const transformXInterval = 12;
	const transformYInterval = 8;
	const rotateInterval = 10.5;
	const skewInterval = 6;
	const scaleInterval = 0.04;

	for (let i = 0; i < 120; i++) {
		const img = new Image();
		img.src = getImageSrc(i + 1);

		preloadedImages.push(img);

		let posX = (i * transformXInterval) / frameCount;
		let posY = (i * transformYInterval) / frameCount;
		let rot = (i * rotateInterval) / frameCount;
		let sk = (i * skewInterval) / frameCount;
		let sc = (Math.abs(i - 60) * scaleInterval) / frameCount;

		let translateX = 44 + posX;
		let translateY = 54 - posY;
		let rotate = -5.25 + rot;
		let skew = -3 + sk;
		let scale = 1 - sc;

		const transformString = `translate3d(-${translateX}%, -${translateY}%, 0) scale(${scale}) rotate(${rotate}deg) skewX(${skew}deg)`;

		transformations.push(transformString);
	}
};
let videoContainer, screenWrapper;

const initialize = () => {
	scene = document.getElementById('scene');
	context = scene.getContext('2d');

	window.addEventListener(
		'contextmenu',
		function (e) {
			e.preventDefault();
		},
		false
	);

	window.addEventListener('dblclick', () => {
		if (!document.fullscreenElement) {
			try {
				document.body.requestFullscreen();
			} catch (error) {}
		} else {
			try {
				document.exitFullscreen();
			} catch (error) {}
		}
	});

	preloadImages();

	currentImage = preloadedImages[midFrame - 1];

	currentImage.onload = function () {
		videoContainer = document.getElementById('videoContainer');
		screenWrapper = document.getElementById('screenWrapper');

		initializeVideo();

		setSizes();
	};
};

const initializeVideo = () => {
	videoContainer.style.display = 'block';
	videoContainer.style.width = `${width}px`;
	videoContainer.style.height = `${height}px`;
	videoContainer.style.left = `${offsetX}px`;
	videoContainer.style.top = `${offsetY}px`;
};

const transformScreen = (frameNumber) => {
	screenWrapper.style.transform = transformations[frameNumber - 1];
};

const setSizes = () => {
	const canvasWidth = window.innerWidth;
	const canvasHeight = window.innerHeight;
	const imageWidth = 1920;
	const imageHeight = 1080;

	scene.width = window.innerWidth;
	scene.height = window.innerHeight;

	const newSizes = cover(canvasWidth, canvasHeight, imageWidth, imageHeight);

	offsetX = newSizes.offsetX;
	offsetY = newSizes.offsetY;
	width = newSizes.width;
	height = newSizes.height;

	if (videoContainer) {
		videoContainer.style.width = `${width}px`;
		videoContainer.style.height = `${height}px`;
		videoContainer.style.left = `${offsetX}px`;
		videoContainer.style.top = `${offsetY}px`;
	}

	draw();
};

const draw = () => {
	context.drawImage(currentImage, offsetX, offsetY, width, height);
};

const updateFrame = (positionDifferential) => {
	const frameNumber = getFrameNumber(positionDifferential);

	const normalizedFrameNumber = limitFrameNumber(frameNumber);

	currentImage = preloadedImages[normalizedFrameNumber - 1];

	draw();

	if (lastFrame !== normalizedFrameNumber) {
		lastFrame = normalizedFrameNumber;
		transformScreen(normalizedFrameNumber);
	}
};

const update = (nextFrame) => {
	const normalizedFrameNumber = limitFrameNumber(nextFrame);

	currentImage = preloadedImages[normalizedFrameNumber - 1];

	draw();

	if (lastFrame !== normalizedFrameNumber) {
		lastFrame = normalizedFrameNumber;
		transformScreen(normalizedFrameNumber);
	}
};

let cursorSwitchInterval;

function App() {
	const overlayRef = React.useRef();

	const [hasDragged, setHasDragged] = React.useState(false);

	const switchCursor = (elementRef) => {
		if (elementRef.current.style.cursor === 'grabbing') {
			elementRef.current.style.cursor = 'grab';
		} else {
			elementRef.current.style.cursor = 'grabbing';
		}
	};

	React.useEffect(() => {
		initialize();

		window.addEventListener('resize', () =>
			requestAnimationFrame(() => {
				setSizes();
			})
		);

		cursorSwitchInterval = setInterval(() => switchCursor(overlayRef), 300);

		return () => clearInterval(cursorSwitchInterval);
	}, []);

	if (hasDragged) {
		clearInterval(cursorSwitchInterval);
	}

	const onDrag = (event) => {
		requestAnimationFrame(() => {
			if (!hasDragged) {
				setHasDragged(true);
			}

			const positionInArea = event.clientX;
			const positionRelativeToInitial = dragInitialPosition - positionInArea;

			updateFrame(positionRelativeToInitial);
		});
	};

	const onDragEnd = () => {
		overlayRef.current.style.cursor = 'grab';

		dragRelease();

		window.removeEventListener('mousemove', onDrag);
		window.removeEventListener('mouseup', onDragEnd);
		window.removeEventListener('touchmove', onDrag);
		window.removeEventListener('touchend', onDragEnd);
	};

	const handleMouseDown = (e) => {
		dragInitialPosition = e.clientX;
		overlayRef.current.style.cursor = 'grabbing';

		dragStart();

		window.addEventListener('mousemove', onDrag);
		window.addEventListener('mouseup', onDragEnd);
		window.addEventListener('touchmove', onDrag);
		window.addEventListener('touchend', onDragEnd);
	};

	return (
		<div className="app">
			<div
				title={!hasDragged ? 'Click and drag to interact' : undefined}
				className="overlay"
				ref={overlayRef}
				onMouseDown={handleMouseDown}
				onTouchStart={handleMouseDown}
			/>
			<canvas id="scene"></canvas>
			<Video />
		</div>
	);
}

export default App;
